<template>
	<div :class="classes">
		<SidebarButton
			v-if="featureOpenSidebar"
			disposition="OPEN"
			size="SMALL"
			type="TERTIARY"
			@click="$emit( `openClick` )"
		/>
		<CalendarButton
			v-if="featureChangeDate"
			size="SMALL"
			type="TERTIARY"
			@change="$emit( `dateChanged`, $event )"
		/>
		<PopMenu
			v-if="featureRecurrence && isHorizontal"
			:options="menuItems"
			@select="onMenuSelection"
		>
			<template #button="{ onClick, }">
				<TeamingButton2
					size="SMALL"
					type="TERTIARY"
					@click="onClick"
				>
					<template #left-icon>
						<FontAwesomeIcon :icon="[ `far`, `calendar-clock` ]" />
					</template>
					<template #default>{{ translate( `scheduleButtonText` ) }}</template>
					<template #right-icon>
						<FontAwesomeIcon :icon="[ `fas`, `caret-down` ]" />
					</template>
				</TeamingButton2>
			</template>
		</PopMenu>
		<CalendarClockButton
			v-else-if="featureRecurrence && isVertical"
			size="SMALL"
			type="TERTIARY"
			@click="$emit( `scheduleRecurrence` )"
		/>
		<SidebarButton
			v-if="featureCloseSidebar"
			:active="true"
			disposition="CLOSE"
			size="SMALL"
			type="SECONDARY"
			@click="$emit( `closeClick` )"
		/>
	</div>
</template>

<script>
import {
	DirectionOrientation
} from "@teaming/common-enums";

import {
	CalendarButton,
	CalendarClockButton,
	makePopMenuOption,
	PopMenu,
	SidebarButton,
	TeamingButton2,
	TranslateMixin
} from "@teaming/common-ui";

export default {
	name: "StreamNavigationToolbar",
	teamingPackage: "common-team",
	mixins: [ TranslateMixin, ],
	emits: [
		"closeClick",
		"dateChanged",
		"openClick",
		"scheduleRecurrence",
	],
	components: {
		CalendarButton,
		CalendarClockButton,
		PopMenu,
		SidebarButton,
		TeamingButton2,
	},
	props: {
		featureChangeDate: {
			type: Boolean,
			default: true,
		},
		featureCloseSidebar: {
			type: Boolean,
			default: true,
		},
		featureOpenSidebar: {
			type: Boolean,
			default: true,
		},
		featureRecurrence: {
			type: Boolean,
			default: true,
		},
		orientation: {
			type: String,
			default: DirectionOrientation.HORIZONTAL,
			validator: value => DirectionOrientation.includes( value ),
		},
	},
	computed: {
		classes() {
			const { isVertical, isHorizontal, } = this;
			return {
				"stream-navigation-toolbar": true,
				"stream-navigation-toolbar--horizontal": isHorizontal,
				"stream-navigation-toolbar--vertical": isVertical,
			};
		},
		isVertical() {
			const { orientation, } = this;
			return orientation === DirectionOrientation.VERTICAL;
		},
		isHorizontal() {
			const { orientation, } = this;
			return orientation === DirectionOrientation.HORIZONTAL;
		},
		menuItems() {
			const { translate, } = this;
			return [
				{
					text: translate( "recurringMeetingOptionText" ),
					value: "createRecurringMeeting",
				},
				{
					text: translate( "oneTimeMeetingOptionText" ),
					value: "createOneTimeMeeting",
				},
				{
					isSeparator: true,
				},
				{
					text: translate( "manageScheduleOptionText" ),
					value: "scheduleRecurrence",
				},
			].map( makePopMenuOption );
		},
	},
	methods: {
		onMenuSelection( { value, } ) {
			this.$emit( value );
		},
	},
};
</script>

<style lang="scss">
.stream-navigation-toolbar__segmented-button {
	.segment {
		@include font-and-line-for(0);
		padding: .35rem .5rem;
	}
}
</style>

<style lang="scss" scoped>
.stream-navigation-toolbar {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 0.5rem;
}

.stream-navigation-toolbar--horizontal {
	flex-direction: row;
}

.stream-navigation-toolbar--vertical {
	flex-direction: column;
}

.stream-navigation-toolbar__segmented-button {
	flex: 1;
}
</style>
